// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/owners.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'bgg.owners',
	post: false,
	require: function(config, filter) { return sorted('bgg.owners', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('g.game_own', sortReverse('bgg.owners', filter), sortPriority('bgg.owners', filter))
	}
}
